// JavaScript Document

  const mainImage = document.getElementById('mainProductImage');
  const thumbnails = document.querySelectorAll('.thumbnail');

  thumbnails.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      // Swap image source
      mainImage.src = thumb.src;

      // Update active thumbnail
      thumbnails.forEach(t => t.classList.remove('selected'));
      thumb.classList.add('selected');
    });
  });


const gallery = document.getElementById('thumbnailGallery');
const leftBtn = document.querySelector('.slider-arrow.left');
const rightBtn = document.querySelector('.slider-arrow.right');

leftBtn.addEventListener('click', () => {
  gallery.scrollBy({ left: -100, behavior: 'smooth' });
});

rightBtn.addEventListener('click', () => {
  gallery.scrollBy({ left: 100, behavior: 'smooth' });
});


/* Mobile Nav*/


/* MOBLE MENU CHANGE */

